// extracted by mini-css-extract-plugin
export default {"info":"about-nav-text1_info__gcrbp","title":"about-nav-text1_title__m9CGT","stepTitle":"about-nav-text1_stepTitle__FwCqG","text":"about-nav-text1_text__xnlxn"};